<app-template-controller *ngIf="editable && isEditIndex"></app-template-controller>
<div class="template_001" id="top" tabindex="-1" [style.margin-top.px]="editable ? 60 : 0" #pageTopAnchor>
  <a *ngIf="isIndex; else another" href="#index_main" pageScroll class="sr-only visually-hidden sr-only-focusable visually-hidden-focusable"
    title="{{'guideTile.toModdle' | translate}}" (click)="focusContentKey()">{{'guideTile.toModdle' | translate}}</a>
  <ng-template #another>
    <a href="#main_content" pageScroll class="sr-only visually-hidden sr-only-focusable visually-hidden-focusable" title="{{'guideTile.toModdle' | translate}}"
      (click)="focusContentKey()">{{'guideTile.toModdle' | translate}}</a>
  </ng-template>
  <header>
    <!-- LOGO -->
    <h1>
      <!-- 原本是col-md-12 logo，請移除col-md-12←不知為何會造成版面右側空白 -->
      <div class="logo" [class.disableClick]="editable">
        <a class="navbar-brand" routerLink="./" title="{{siteInfo?.metadata?.title}}">
          <img src="{{logoImageFile && logoImageFile.url || '/assets/images/logo2.webp'}}" alt="{{siteInfo?.metadata?.title}}" width="252" height="60"
          tmErrorDefaultImage="/assets/images/logo2.webp">
        </a>
      </div>
    </h1>
    <!-- /.LOGO -->
    <!-- 搜尋、導航、語系 -->
    <nav class="navbar navbar-default navbar-top" [class.disableClick]="editable" attr.aria-label="{{'navigation_bar' | translate}}">
      <div class="container-fluid">
        <!-- <div class="row">
            <div class="col-md-12"> -->
        <a href="#top" pageScroll title="{{'guideTile.top' | translate}}" class="key" accesskey="U">:::</a>
        <!-- </div>
          </div> -->
      </div>
    </nav>
    <!-- /.搜尋、導航、語系 -->
    <!-- 選單區塊 -->
    <nav class="navbar navbar-default navbar-style" [class.disableClick]="editable || !menus" attr.aria-label="{{'Site_menu' | translate}}">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle" (click)="mainMenuModal.show()"
              attr.aria-label="{{'openMenu' | translate}}">
                <span class="sr-only visually-hidden">{{'openMenu' | translate}}</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div class="collapse navbar-collapse" id="defaultNavbar1">
              <!-- 行動版語系-->
              <!-- <ul class="nav navbar-nav nav-menu" *ngIf="metadata && metadata.showLang && langs.length != 1">
                <li class="dropdown lang mb">
                  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" id="lang_dropdown"
                  [tmCloseOnContainerBlur]="langDDMenu2">
                    {{currentLang | translate}}
                  </a>
                  <div class="dropdown-menu" aria-labelledby="lang_dropdown" #langDDMenu2>
                    <ng-container *ngFor="let lang of langs"><a href="/{{lang}}" class="dropdown-item">{{lang | translate}}</a></ng-container>
                  </div>
                </li>
              </ul> -->
              <!-- /.行動版語系 -->
              <!-- 選單 -->
              <ul class="nav navbar-nav nav-menu">
                <li routerLinkActive="active"><a routerLink="./subject" title="{{'subjectPage.title' | translate}}">{{'subjectPage.title' | translate}}</a></li>
                <li routerLinkActive="active"><a routerLink="./explore" title="{{'explorePage.title2025' | translate}}">{{'explorePage.title2025' | translate}}</a></li>
                <li routerLinkActive="active"><a routerLink="./interact" title="{{'quiz.title' | translate}}">{{'quiz.title' | translate}}</a></li>
                <li routerLinkActive="active"><a routerLink="./participate" title="{{'participatePage.title' | translate}}">{{'participatePage.title' | translate}}</a></li>
                <li routerLinkActive="active"><a routerLink="./curation" title="{{'curating' | translate}}">{{'curating' | translate}}</a></li>
                <li class="pc">
                  <button type="button" class="navbar-toggle2" (click)="mainMenuModal.show()"
                  attr.aria-label="{{'openMenu' | translate}}"
                  [tmCloseOnContainerBlur]="mainMenu" #mainMenuCcb="tmCCB"
                  #menuOpenBtn>
                    <span class="sr-only visually-hidden">{{'openOrCloseMainMenu' | translate}}</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>
                </li>
                <li class="lang home fb"
                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                *ngIf="metadata && metadata.index">
                  <a class="nav-link waves-effect waves-dark profile-pic" title="{{'home' | translate}}"
                  routerLink="./">
                    <img src="/assets/images/v001/icon_01.webp" alt="{{'home' | translate}}" class="">
                  </a>
                </li>
                <li class="quickLink fb"
                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                *ngIf="metadata && metadata.sitemap">
                  <a class="nav-link waves-effect waves-dark profile-pic" title="{{'sitemap'| translate}}"
                  routerLink="./sitemap">
                    <img src="/assets/images/v001/icon_02.webp" alt="{{'sitemap'| translate}}" class="">
                  </a>
                </li>
                <li class="quickLink fb" [class.member-loading]="loginIng" [class.member-show]="memberInfo"  *ngIf="hasLoginSys">
                  <ng-container *ngIf="!memberInfo">
                    <a class="nav-link waves-effect waves-dark profile-pic"
                    href="javascript:void(0)" (click)="openCultureCenterLogin()" role="button"
                    title="{{'openLoginWindow' | translate}}[{{'openNewWindow' | translate}}]">
                      <img src="/assets/images/v001/icon_03.webp" alt="{{'memberPage' | translate}}" class="">
                    </a>
                  </ng-container>
                  <ng-container *ngIf="memberInfo">
                    <div class="dropdown nav-link waves-effect waves-dark profile-pic">
                      <a href="javascript:void(0)" class="dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false" id="memberDropdown" title="{{'memberPage' | translate}}">
                        <img src="/assets/images/v001/icon_03_on.webp" alt="{{'memberPage' | translate}}" class="">
                      </a>
                      <ul class="dropdown-menu" aria-labelledby="memberDropdown">
                        <li>
                          <div class="member-name">{{ 'hello2' | translate: ({value: memberInfo.name}) }}</div>
                        </li>
                        <li><a class="dropdown-item" [routerLink]="[toHomePath, 'memberCollection']" routerLinkActive="active">{{'memberCollection' | translate}}</a></li>
                        <li><a class="dropdown-item" href="javascript:void(0)" role="button" tabindex="0" (click)="openPrefere()">{{'contentPreferences' | translate}}</a></li>
                        <li>
                          <a class="dropdown-item member-logout-btn" href="javascript:void(0)" role="button" tabindex="0"
                          (click)="logout()" title="{{'logout' | translate}}">{{'logout' | translate}}</a>
                        </li>
                      </ul>
                      <app-member-preference-modal></app-member-preference-modal>
                    </div>
                  </ng-container>
                </li>
                <!-- 語系 -->
                <li class="lang pc dropdown">
                  <a href="javascript: void(0)" role="button" class="dropdown-toggle" id="lang_dropdown"
                  data-bs-toggle="dropdown" [tmCloseOnContainerBlur]="langDDMenu">
                    <span class="m-r-xs"></span>{{currentLang | translate}}<b class="caret"></b>
                  </a>
                  <ul class="dropdown-menu" aria-labelledby="lang_dropdown" #langDDMenu>
                    <ng-container  *ngFor="let lang of langs">
                      <li><a href="javascript:void(0)" (click)="goTranslate(lang)">{{lang | translate}}</a></li>
                    </ng-container>
                  </ul>
                </li>
                <li id="google_translate_element" class="pc googleTranslateElement"
                style="width: 74px;height:23px;line-height: 23px;"
                *ngIf="narBar && narBar.googleTranslateView"></li>
                <!-- /.語系 -->
              </ul>
            </div>
            <!-- /.選單 -->
          </div>
        </div>
      </div>
    </nav>
    <!-- /.選單區塊 -->
  </header>

  <!-- 內容區塊 -->
  <div id="index_main">
    <!-- 主要內容區塊的guideTile -->
    <a *ngIf="isIndex ; else anotherPage" href="#index_main" pageScroll [class.disableClick]="editable" title="{{'guideTile.middle' | translate}}" class="key" accesskey="C" #contentAnchor>:::</a>
    <ng-template #anotherPage>
      <a id="main_content" href="#main_content" pageScroll [class.disableClick]="editable" title="{{'guideTile.middle' | translate}}" class="key" accesskey="C" #contentAnchor style="top: 10px;">:::</a>
    </ng-template>
    <!-- /主要內容區塊的guideTile -->

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>

  </div>
  <!-- /.內容區塊 -->

  <!-- 浮動功能工具列 -->
  <div class="floating-toolbar noPrint" attr.aria-label="{{'webToolBar' | translate}}" *ngIf="!editable">
    <!-- 字體放大 -->
    <button class="toolbar-button" attr.aria-label="{{'growFontSize' | translate}}" title="{{'growFontSize' | translate}}"
    (click)="growUPFontSize()">
      <img src="/assets/images/v001/icon_10.png" width="30" height="30" alt="{{'growFontSize' | translate}}"/>
    </button>

    <!-- 恢復預設字體大小 -->
    <button class="toolbar-button" attr.aria-label="{{'resetFontSize' | translate}}" title="{{'resetFontSize' | translate}}"
    (click)="resetUPFontSize()">
      <img src="/assets/images/v001/icon_11.png" width="30" height="30" alt="{{'resetFontSize' | translate}}"/>
    </button>

    <!-- 字體縮小 -->
    <button class="toolbar-button" attr.aria-label="{{'shrinkFontSize' | translate}}" title="{{'shrinkFontSize' | translate}}"
    (click)="shrinkUPFontSize()">
      <img src="/assets/images/v001/icon_12.png" width="30" height="30" alt="{{'shrinkFontSize' | translate}}"/>
    </button>
  </div>
  <!-- /.浮動功能工具列 -->

  <!-- 表尾資訊 -->
  <footer id="footer">
    <a href="#footer" pageScroll title="{{'guideTile.bottom' | translate}}" class="key" [class.disableClick]="editable" accesskey="B">:::</a>

    <!--footer site-->
    <app-footer-controler [showFooter]="showFooter" *ngIf="editable"></app-footer-controler>
    <ng-container *ngIf="editable || showFooter">
      <!-- <ng-container *ngTemplateOutlet="menuTmp; context: {$implicit: footerSiteMap}"></ng-container> -->
      <div class="trigger hidden-xs">
        <a class="btn collapsed" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
          <span>{{'expandsiteMap' | translate}}</span>
        </a>
      </div>
      <div class="col-lg-10 offset-lg-1 col-md-12 site hidden-xs collapse" id="collapseExample">
        <div class="site_o" [class.disableClick]="editable" *ngIf="footerSiteMap">
          <div class="col">
            <div class="row">
              <div class="col-md-2">
                <div class="">
                  <p class="fw-bold fs-3 mb-3"><a routerLink="/" title="{{'home' | translate}}">{{'home' | translate}}</a></p>
                  <p class="fw-bold fs-3 mb-3"><a routerLink="./subject" title="{{'subjectPage.title' | translate}}">{{'subjectPage.title' | translate}}</a></p>
                  <p class="fw-bold fs-3 mb-3"><a routerLink="./explore" title="{{'explorePage.title2025' | translate}}">{{'explorePage.title2025' | translate}}</a></p>
                  <p class="fw-bold fs-3 mb-3"><a routerLink="./interact" title="{{'quiz.title' | translate}}">{{'quiz.title' | translate}}</a></p>
                  <p class="fw-bold fs-3 mb-3"><a routerLink="./participate" title="{{'participatePage.title' | translate}}">{{'participatePage.title' | translate}}</a></p>
                  <p class="fw-bold fs-3 mb-3"><a routerLink="./curation" title="{{'curating' | translate}}">{{'curating' | translate}}</a></p>
                </div>
              </div>

              <div class="col-md-10 site_r_o">
                <ng-container *ngFor="let siteItem of footerSiteMap">
                  <div class="site_r">
                    <p class="fw-bold fs-3 mb-3">
                      <ng-container *ngIf="siteItem.module == 'LINKING'">
                        <a title="{{siteItem.title}}[{{'openNewWindow' | translate}}]" href="{{siteItem?.otherSetting.url}}" target="_blank">{{siteItem.title}}</a>
                      </ng-container>
                      <ng-container *ngIf="siteItem.module != 'LINKING'">
                        <span *ngIf="siteItem.module == 'EMPTY'">{{siteItem.title}}</span>
                        <a *ngIf="siteItem.module != 'EMPTY'" title="{{siteItem.title}}" routerLink="./{{siteItem.path | appPath}}">{{siteItem.title}}</a>
                      </ng-container>
                    </p>
                    <ng-container *ngIf="siteItem.menus?.length > 0">
                      <ng-container *ngFor="let subSiteItem of siteItem.menus">
                        <p class="">
                          <ng-container *ngIf="subSiteItem.module == 'LINKING'">
                            <a title="{{subSiteItem.title}}[{{'openNewWindow' | translate}}]" href="{{subSiteItem?.otherSetting.url}}" target="_blank">{{subSiteItem.title}}</a>
                          </ng-container>
                          <ng-container *ngIf="subSiteItem.module != 'LINKING'">
                            <span *ngIf="subSiteItem.module == 'EMPTY'">{{subSiteItem.title}}</span>
                            <a *ngIf="subSiteItem.module != 'EMPTY'" title="{{subSiteItem.title}}" routerLink="./{{subSiteItem.path | appPath}}">{{subSiteItem.title}}</a>
                          </ng-container>
                        </p>
                        <ng-container *ngIf="subSiteItem.menus?.length > 0">
                          <ng-container *ngFor="let thirdSiteItem of subSiteItem.menus">
                            <p class="site_third">
                              <ng-container *ngIf="thirdSiteItem.module == 'LINKING'">
                                <a title="{{thirdSiteItem.title}}[{{'openNewWindow' | translate}}]" href="{{thirdSiteItem?.otherSetting.url}}" target="_blank">{{thirdSiteItem.title}}</a>
                              </ng-container>
                              <ng-container *ngIf="thirdSiteItem.module != 'LINKING'">
                                <span *ngIf="thirdSiteItem.module == 'EMPTY'">{{thirdSiteItem.title}}</span>
                                <a *ngIf="thirdSiteItem.module != 'EMPTY'" title="{{thirdSiteItem.title}}" routerLink="./{{thirdSiteItem.path | appPath}}">{{thirdSiteItem.title}}</a>
                              </ng-container>
                            </p>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="footer">
      <ng-container *ngIf="footer.navigate">
        <div class="center link fr-view" [class.disableClick]="editable" [innerHtml]="$any(footer.navigate | safe: 'html')">
          <!-- <ul class="footer-about mb-3">
            <li><a href="####" title="關於我們">關於我們</a></li>
            <li><a href="####" title="發展史">發展史</a></li>
            <li><a href="####" title="大事記">大事記</a></li>
            <li><a href="####" title="資訊安全政策">資訊安全政策</a></li>
            <li><a href="####" title="隱私權保護政策">隱私權保護政策</a></li>
          </ul> -->
        </div>
      </ng-container>

      <div class="row">
        <div class="left">
          <ng-container *ngIf="footer.content">
            <div class="footer-row fr-view" [class.disableClick]="editable" [innerHtml]="$any(footer.content | safe: 'html')">
              <!-- <div>
                <div class="d-inline-block">
                  <img src="/assets/images/v001/logo.2af4784c.webp" class="footer-logo">
                </div>
                <p class="mb-0">地址：709025 臺南市安南區長和路一段250號　</p>
                <p class=" mb-0">電話：02-6631-6711／02-6605-7331　客服信箱 </p>
                <p class="">服務時段：周一至周五 09:30 - 12:30 至 13:30 - 18:30</p>
                <p>copyright @ 國立臺灣歷史博物館 版權所有　建議瀏覽器 Firefox、Chrome、edge 以上版本</p>
				        <p><img src="https://tcmbfile.culture.tw/image/2023-03-02/708f9354-0071-4205-bdbc-171c5eeb980b/f547632c-629b-4bef-9978-2dc34503610d.png?X-Goog-Algorithm=GOOG4-RSA-SHA256&amp;X-Goog-Credential=995230324304-compute%40developer.gserviceaccount.com%2F20250725%2Fauto%2Fstorage%2Fgoog4_request&amp;X-Goog-Date=20250725T022444Z&amp;X-Goog-Expires=900&amp;X-Goog-SignedHeaders=host&amp;X-Goog-Signature=092e79cd37c962210c2f6423e43c0b7c7b4631cbf6678846f8db2f0e7a0ec11acd1333fe7953b2d3d7c9ef9f60f4f21e8abd405e932d3aaca7cb0d0eb00a9877470b1c05dd2373607033bc3bb4c737a892319a3922f60885084dbcac4cb88ffb39b2903e3d0d472a5dc72d4464a40cd008e931189502874ffddf02fa12aa4f9cf1bd823aeede32ff5dccea18d773cb902bc4454bc6c942b545c0d6819906004ea408b73d200d82a74a32a2e7c43209ce878c860e62ad7ae4f317a0ad07c170dc6abd22a02679af8e61f6cc3d5a94db9a48c292f3f49ae68e2ca0116c962a111d9f07d02bb2ad544343d392728f53220c3b035f9c7c17c012574c065b8a415f7f" style="width: 100px;" class="fr-fic fr-dib fr-fil"></p>
              </div> -->
            </div>
          </ng-container>
        </div>
        <div class="right">
          <div class="soc">
            <!-- 社群 -->
            <div class="social" [class.disableClick]="editable">
              <ul>
                <li *ngIf="narBar.facebook">
                  <a href="{{narBar.facebook}}" title="Facebook[{{'openNewWindow' | translate}}]" target="_blank" rel="noopener noreferrer"><i class="fab fa fa-facebook-square" aria-hidden="true"></i><span class="sr-only visually-hidden">Facebook</span></a>
                </li>
                <li *ngIf="narBar.instagram">
                  <a href="{{narBar.instagram}}" title="instagram[{{'openNewWindow' | translate}}]" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa fa-instagram" aria-hidden="true"></i><span class="sr-only visually-hidden">instagram</span></a>
                </li>
                <li *ngIf="narBar.youtube">
                  <a href="{{narBar.youtube}}" title="youtube[{{'openNewWindow' | translate}}]" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa fa-youtube-play" aria-hidden="true"></i><span class="sr-only visually-hidden">youtube</span></a>
                </li>
              </ul>
              <!-- /.社群 -->
              <!-- 無障礙標章 -->
              <ng-container *ngIf="footer.enableAccessibility && footer.accessibilityContent">
                <div [class.disableClick]="editable" [innerHtml]="$any(footer.accessibilityContent | safe: 'html')">
                  <!-- <img src="/assets/images/accessibilityAA.jpg" class="w-auto pe-3"> -->
                </div>
              </ng-container>
              <!-- /. 無障礙標章 -->
              <ng-container *ngIf="footer.copyright">
              <div class="fr-view" [class.disableClick]="editable" [innerHtml]="$any(footer.copyright | safe: 'html')"></div>
              </ng-container>
              <!-- <div>copyright @ 國立臺灣歷史博物館 版權所有　建議瀏覽器 Firefox、Chrome、edge 以上版本 </div> -->
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </footer>
  <!-- /.表尾資訊 -->

  <a href="#top" pageScroll class="back-top" title="{{'toTop' | translate}}" [@fadeInOut]="showGoTop" (click)="setFocusTop()"><span>{{'toTop' | translate}}</span></a>
</div>

<div class="modal fade" id="onload" tabindex="-1" aria-labelledby="onloadlLabel" aria-hidden="true"
  appBs5Modal #bulletinModal="appBs5Modal" role="dialog" data-bs-backdrop="static" (hiddened)="closeBulletin()">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title text-danger ps-3" id="onloadlLabel">網站公告</h5>
        <button type="button" class="btn-close fs-1" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body px-5 pb-5">

        <!-- <p class="fw-bold fs-2 mb-3 text-danger">網站公告</p> -->

        <div class="row">
          <p class="fw-bolder fs-1 mb-3">「國家文化記憶庫」滿意度調查開跑，填寫即抽 500 元超商商品卡！</p>
          <p class="fs-2">
            親愛的使用者，您好！</p>
          <p class="fs-2">為了打造更貼近您需求的網站服務、提升核心功能的使用體驗，我們誠摯邀請您撥冗填寫這份滿意度調查問卷，預計需時約 6-8
            分鐘。您的寶貴意見，無論是讚美或建議，都將成為我們未來改進網站的重要依據，幫助我們將這座線上記憶寶庫打造得更友善、更豐富、更好用！</p>
          <p class="fs-2">問卷連結：<a href="https://forms.gle/tyQLdiCmBHJidpLp7" target="_blank" title="填寫問卷（開新視窗）">
              https://forms.gle/tyQLdiCmBHJidpLp7</a> (點擊前往填寫)</p>
          <div class="row">
            <img src="/assets/images/v001/sBANNER800X595_comp.webp" class="img-fluid">
          </div>

        </div>
        <!--<div class="modal-footer">
           <button type="button" class="btn btngray" data-bs-dismiss="modal">關閉視窗</button>
          <button type="button" class="btn btnblue">重新檢查</button>
        </div>-->
      </div>
    </div>
  </div>
</div>

<div class="modal fade search_04" id="menu" tabindex="-1" aria-hidden="true"  role="dialog" data-bs-backdrop="static" #mainMenu
appBs5Modal #mainMenuModal="appBs5Modal" (showned)="menuCloseBtn.focus();" (hiddened)="menuOpenBtn.focus();">
  <div class="modal-dialog modal-lg  modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" attr.aria-label="{{'closeMenu' | translate}}" #menuCloseBtn>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <section class="row clearfix bg-img p-h-md" id="top_function">
          <div class="row area1">
            <ul class="rwd-nav-menu">
              <li class="lang home fb" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="metadata && metadata.index">
                <a class="nav-link waves-effect waves-dark profile-pic" title="{{'home' | translate}}" routerLink="./">
                  <img src="/assets/images/v001/icon_01.webp" alt="{{'home' | translate}}" class="">
                </a>
              </li>
              <li class="quickLink fb" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="metadata && metadata.sitemap">
                <a class="nav-link waves-effect waves-dark profile-pic" title="{{'sitemap'| translate}}"
                routerLink="./sitemap">
                <img src="/assets/images/v001/icon_02.webp" alt="{{'sitemap'| translate}}" class=""> </a>
              </li>
              <li class="quickLink fb" [class.member-loading]="loginIng" [class.member-show]="memberInfo"  *ngIf="hasLoginSys">
                <ng-container *ngIf="!memberInfo">
                  <a class="nav-link waves-effect waves-dark profile-pic"
                  href="javascript:void(0)" (click)="openCultureCenterLogin()" role="button"
                  title="{{'openLoginWindow' | translate}}[{{'openNewWindow' | translate}}]">
                    <img src="/assets/images/v001/icon_03.webp" alt="{{'memberPage' | translate}}" class="">
                  </a>
                </ng-container>
                <ng-container *ngIf="memberInfo">
                  <div class="dropdown nav-link waves-effect waves-dark profile-pic">
                    <a href="javascript:void(0)" class="dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false" id="memberDropdown" title="{{'memberPage' | translate}}">
                      <img src="/assets/images/v001/icon_03_on.webp" alt="{{'memberPage' | translate}}" class="">
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="memberDropdown">
                      <li>
                        <div class="member-name">{{ 'hello2' | translate: ({value: memberInfo.name}) }}</div>
                      </li>
                      <li><a class="dropdown-item" [routerLink]="[toHomePath, 'memberCollection']" routerLinkActive="active">{{'memberCollection' | translate}}</a></li>
                      <li><a class="dropdown-item" href="javascript:void(0)" role="button" tabindex="0" (click)="openPrefere()">{{'contentPreferences' | translate}}</a></li>
                      <li>
                        <a class="dropdown-item member-logout-btn" href="javascript:void(0)" role="button" tabindex="0"
                        (click)="logout()" title="{{'logout' | translate}}">{{'logout' | translate}}</a>
                      </li>
                    </ul>
                    <app-member-preference-modal></app-member-preference-modal>
                  </div>
                </ng-container>
              </li>
              <!-- 語系 -->
              <li class="lang pc">
                <a href="#" role="button" class="dropdown-toggle" id="lang_dropdown_mb"
                data-bs-toggle="dropdown" [tmCloseOnContainerBlur]="langDDMBMenu">
                  <span class="m-r-xs"></span>{{currentLang | translate}}<b class="caret"></b>
                </a>
                <ul class="dropdown-menu" aria-labelledby="lang_dropdown_mb" #langDDMBMenu>
                  <ng-container  *ngFor="let lang of langs">
                    <li><a href="javascript:void(0)" (click)="goTranslate(lang)">{{lang | translate}}</a></li>
                  </ng-container>
                </ul>
              </li>
              <li id="google_translate_element" class="pc googleTranslateElement"
              style="width: 74px;height:23px;line-height: 23px;"
              *ngIf="narBar && narBar.googleTranslateView"></li>
            </ul>

            <div class="col-lg-10 col-lg-offset-1 col-md-12 site ">
              <div class="sitetab-list">
                <div class="c-tab"><a routerLink="./subject" title="{{'subjectPage.title' | translate}}">{{'subjectPage.title' | translate}}</a></div>
                <div class="c-tab"><a routerLink="./explore" title="{{'explorePage.title2025' | translate}}">{{'explorePage.title2025' | translate}}</a></div>
                <div class="c-tab"><a routerLink="./interact" title="{{'quiz.title' | translate}}">{{'quiz.title' | translate}}</a></div>
                <div class="c-tab"><a routerLink="./participate" title="{{'participatePage.title' | translate}}">{{'participatePage.title' | translate}}</a></div>
                <div class="c-tab"><a routerLink="./curation"title="{{'curating' | translate}}">{{'curating' | translate}}</a></div>
              </div>
            </div>
            <div class="col-lg-10 col-lg-offset-1 col-md-12 site" *ngIf="menus">
              <dl class="" *ngFor="let siteItem of menus">
                <dt>
                  <ng-container *ngIf="siteItem.module == 'LINKING'">
                    <a title="{{siteItem.title}}[{{'openNewWindow' | translate}}]" href="{{siteItem?.otherSetting.url}}" target="_blank">{{siteItem.title}}</a>
                  </ng-container>
                  <ng-container *ngIf="siteItem.module != 'LINKING'">
                    <span *ngIf="siteItem.module == 'EMPTY'">{{siteItem.title}}</span>
                    <a *ngIf="siteItem.module != 'EMPTY'" title="{{siteItem.title}}" routerLink="./{{siteItem.path | appPath}}">{{siteItem.title}}</a>
                  </ng-container>
                </dt>
                <ng-container *ngIf="siteItem.menus?.length > 0">
                  <ng-container *ngFor="let subSiteItem of siteItem.menus">
                    <dd>
                      <ng-container *ngIf="subSiteItem.module == 'LINKING'">
                        <a class="dda" title="{{subSiteItem.title}}[{{'openNewWindow' | translate}}]" href="{{subSiteItem?.otherSetting.url}}" target="_blank">{{subSiteItem.title}}</a>
                      </ng-container>
                      <ng-container *ngIf="subSiteItem.module != 'LINKING'">
                        <span class="dda" *ngIf="subSiteItem.module == 'EMPTY'">{{subSiteItem.title}}</span>
                        <a class="dda" *ngIf="subSiteItem.module != 'EMPTY'" title="{{subSiteItem.title}}" routerLink="./{{subSiteItem.path | appPath}}">{{subSiteItem.title}}</a>
                      </ng-container>
                    </dd>
                    <ng-container *ngIf="subSiteItem.menus?.length > 0">
                      <ng-container *ngFor="let thirdSiteItem of subSiteItem.menus">
                        <dd class="sub">
                          <ng-container *ngIf="thirdSiteItem.module == 'LINKING'">
                            <a class="dda" title="{{thirdSiteItem.title}}[{{'openNewWindow' | translate}}]" href="{{thirdSiteItem?.otherSetting.url}}" target="_blank">{{thirdSiteItem.title}}</a>
                          </ng-container>
                          <ng-container *ngIf="thirdSiteItem.module != 'LINKING'">
                            <span class="dda" *ngIf="thirdSiteItem.module == 'EMPTY'">{{thirdSiteItem.title}}</span>
                            <a class="dda" *ngIf="thirdSiteItem.module != 'EMPTY'" title="{{thirdSiteItem.title}}" routerLink="./{{thirdSiteItem.path | appPath}}">{{thirdSiteItem.title}}</a>
                          </ng-container>
                        </dd>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </dl>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
